export class Phone {
    constructor(element) {
        this.input = $(element);

        this.setMask();
    }
    setMask() {
        let mask = '+7 (999) 999-99-99';

        if (this.input.data('mask')) {
            mask = this.input.data('mask');
        }

        this.input.inputmask(mask);
    }
}